import { PlannerEcsSystem } from '@inter-ikea-storageone/range';
import { ComponentIds, HierarchyUtils, ProductUtils, Quaternion, Transform, TransformUtils } from '@inter-ikea-core/core';
const vastervikenDoorIds = [
    'S80489242_ASM',
    'S30487863_ASM',
    'S80495709_ASM',
    'S10489245_ASM',
    'S00487888_ASM',
    'S60495710_ASM'
];
const hammarsmedDoorIds = ['S00590362_ASM', 'S00590376_ASM', 'S70590373_ASM', 'S80590377_ASM'];
/**
 * VÄSTERVIKEN and HAMMARSMED doors in BESTÅ have an integrated handle in top/bottom. The door should be rotated
 * so the handle is facing upwards if door is below 120cm height and otherwise it should be
 * facing downward
 */
export class DoorRotationSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'DoorRotationSystem', ComponentIds.MOVED_TO_VALID_SNAP_POSITION_COMPONENT_ID);
    }
    onAdd(entity) {
        let doorFrontsToRotate = [];
        if (entity.hasComponent(ComponentIds.FRAME_COMPONENT_ID)) {
            // Frame is snapped to new posittion. Check if it has VÄSTERVIKEN or HAMMARSMED doors and in that case check if they need to be rotated
            const doorsOnFrame = HierarchyUtils.descendants(entity).filter(child => child.hasComponent(ComponentIds.DOOR_COMPONENT_ID));
            const doorsToRotate = doorsOnFrame.filter(door => [...vastervikenDoorIds, ...hammarsmedDoorIds].includes(ProductUtils.productRefOrEmptyString(door)));
            doorFrontsToRotate = doorsToRotate.flatMap(door => HierarchyUtils.descendants(door).filter(child => child.hasComponent(ComponentIds.DOOR_FRONT_COMPONENT_ID)));
        }
        else if ([...vastervikenDoorIds, ...hammarsmedDoorIds].includes(ProductUtils.productRefOrEmptyString(entity))) {
            // Door is snapped to new position. Check if it needs to be rotated
            doorFrontsToRotate = HierarchyUtils.descendants(entity).filter(child => child.hasComponent(ComponentIds.DOOR_FRONT_COMPONENT_ID));
        }
        doorFrontsToRotate.forEach(doorFront => {
            const transform = TransformUtils.worldTransform(doorFront);
            if (transform.position.Y > 1200 &&
                (transform.rotation.w > 0.99 || transform.rotation.w < -0.99)) {
                const newTransform = new Transform(transform.position, Quaternion.fromCoefficients(0, 0, 0, 1));
                TransformUtils.setWorldTransform(doorFront, newTransform);
            }
            else if (transform.position.Y <= 1200 &&
                (transform.rotation.z > 0.99 || transform.rotation.z < -0.99)) {
                const newTransform = new Transform(transform.position, Quaternion.fromCoefficients(1, 0, 0, 0));
                TransformUtils.setWorldTransform(doorFront, newTransform);
            }
        });
    }
    onUpdate() { }
    onRemove() { }
}
//# sourceMappingURL=DoorRotationSystem.js.map